var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Steps, UserFields, UserToUpdate, MeetingTypes } from './SignupForm.constants';
import T from './Locale';
import createZendeskTicket from '../../Utils/ZendeskTicketCreator';
export function getVisibleSteps(currentStep) {
    const stepValues = Object.values(Steps);
    return stepValues.slice(0, stepValues.indexOf(currentStep) + 1);
}
export const createTicket = (userFirst, userSecond) => __awaiter(void 0, void 0, void 0, function* () {
    const content = [
        T('partner.signup.process'),
        '',
        `${T('misc.url')}: ${window.location.href}`
    ];
    if (userFirst[UserFields.IS_ADVISOR]) {
        content.push(`${T('partner.signup.advisorId')}: ${userFirst[UserFields.ADVISOR_ID]}`);
        content.push(`${T('partner.signup.branchId')}: ${userFirst[UserFields.BRANCH_ID]}`);
        content.push(`${T('partner.signup.phoneOrFaceToFaceMeeting.question')}: ${userFirst[UserFields.MEETING_TYPE] === MeetingTypes.PHONE ? T('partner.signup.phoneOrFaceToFaceMeeting.phone') : T('partner.signup.phoneOrFaceToFaceMeeting.faceToFace')}`);
        content.push(`${T('partner.signup.sharingScreenWithCustomer.question')}: ${userFirst[UserFields.SHARING_SCREEN] ? T('misc.yes') : T('misc.no')}`);
        content.push(`${T('partner.signup.isPartnerPresentAtMeeting.question')}: ${userFirst[UserFields.PARTNER_PRESENT] ? T('misc.yes') : T('misc.no')}`);
    }
    content.push('');
    content.push(`${T('partner.signup.firstUser')}`);
    content.push(`${T('partner.signup.fullName')}: ${userFirst[UserFields.FIRST_NAME]} ${userFirst[UserFields.LAST_NAME]}`);
    content.push(`${T('partner.signup.email')}: ${userFirst[UserFields.EMAIL]}`);
    content.push(`${T('partner.signup.phone')}: ${userFirst[UserFields.PHONE]}`);
    if (userFirst[UserFields.PARTNER_PRESENT]) {
        content.push('');
        content.push(`${T('partner.signup.secondUser')}`);
        content.push(`${T('partner.signup.fullName')}: ${userSecond[UserFields.FIRST_NAME]} ${userSecond[UserFields.LAST_NAME]}`);
        content.push(`${T('partner.signup.email')}: ${userSecond[UserFields.EMAIL]}`);
        content.push(`${T('partner.signup.phone')}: ${userSecond[UserFields.PHONE]}`);
        content.push('');
        content.push(`${T('partner.signup.primary')}: ${userFirst[UserFields.PRIMARY_CONTACT] === UserToUpdate.SECOND ? T('partner.signup.secondUser') : T('partner.signup.firstUser')}`);
    }
    content.push('');
    content.push(`${T('partner.signup.marital.title')}: ${T(`partner.signup.marital.${userFirst[UserFields.MARITAL]}`)}`);
    content.push(`${T('partner.signup.living')}: ${userFirst[UserFields.RESIDENCE] ? T('misc.yes') : T('misc.no')}`);
    content.push(`${T('partner.signup.marriagePlanned')}: ${userFirst[UserFields.MARRIAGE] ? T('misc.yes') : T('misc.no')}`);
    content.push(`${T('partner.signup.childrenPartner')}: ${userFirst[UserFields.CHILDREN] ? T('misc.yes') : T('misc.no')}`);
    content.push(`${T('partner.signup.ownChildrenPartner')}: ${userFirst[UserFields.CHILDREN_OUTSIDE_RELATIONSHIP] ? T('misc.yes') : T('misc.no')}`);
    if (userFirst[UserFields.DOCUMENTS]) {
        content.push(`${T('partner.signup.documents.titlePartner')}: ${userFirst[UserFields.DOCUMENTS].map(document => T(`products.${document}`)).join(', ')}`);
    }
    if (userFirst[UserFields.ASSETS]) {
        content.push(`${T('partner.signup.assets.titlePartner')}: ${userFirst[UserFields.ASSETS].map(asset => T(`partner.signup.assets.${asset}`)).join(', ')}`);
    }
    if (userFirst[UserFields.COMMENT]) {
        content.push(`${T('partner.signup.comment')}: ${userFirst[UserFields.COMMENT]}`);
    }
    if (userFirst[UserFields.CONSENTS]) {
        content.push(`${T('partner.signup.consent.title')}: ${Object.keys(userFirst[UserFields.CONSENTS]).map(consent => T(`partner.signup.consent.${consent}`)).join(', ')}`);
    }
    if (userFirst[UserFields.PRODUCTS] && userFirst[UserFields.PRODUCTS].length > 0) {
        content.push(`${T('partner.documents.selectDocument')}: ${userFirst[UserFields.PRODUCTS].map(document => document.document).join(', ')}`);
        content.push(`${T('partner.documents.selectType')}: ${userFirst[UserFields.PRODUCTS][0].purchase_type}`);
    }
    if (userFirst[UserFields.BOOKING]) {
        content.push(`${T('partner.timeBooking.title')}: ${userFirst[UserFields.BOOKING]}`);
    }
    return yield createZendeskTicket('info@testaviva.dk', 'TestaViva', T('partner.signup.errors.error_create_ticket_subject'), content.join('\\r\\n'));
});
export function scrollToContainerBottom(container) {
    const containerRect = container.getBoundingClientRect();
    const scrollTo = window.scrollY + containerRect.height;
    window.scroll({
        top: scrollTo,
        left: 0,
        behavior: 'smooth'
    });
}
